<div class="px-6">
  <p-toast position="top-right" key="toastError"></p-toast>
  <p-toast position="top-right" key="toastSuccess"></p-toast>

  <p-tabView [(activeIndex)]="activeTabIndex" (onChange)="onTabChange($event)" styleClass="tabview-custom">
  <p-tabPanel header="Início de Operação">

  <!-- Filtros -->
  <p-card styleClass="my-3">
    <p-fieldset legend="Filtros" [toggleable]="true">
      <div class="grid mt-3">
        <div class="col-4">
          <span class="p-float-label">
            <p-dropdown
              [scrollHeight]="'30rem'"
              [style]="stylePattern"
              [options]="contracts"
              inputId="filtroContrato"
              optionLabel="description"
              optionValue="id"
              [(ngModel)]="filter.contratoId"
              [disabled]="true"
              dropdownIcon="null"
              placeholder="Selecionar"
            ></p-dropdown>
            <label htmlFor="filtroContrato">Contrato</label>
          </span>
        </div>
        <div class="col-4">
          <span class="p-float-label">
            <p-multiSelect
              [style]="stylePattern"
              [options]="lotes"
              optionLabel="nome"
              optionValue="id"
              [(ngModel)]="filter.loteId"
              inputId="filtroLote"
              [showClear]="true"
              [filter]="true"
              placeholder="Selecionar"
              emptyMessage="Nenhum lote disponível"
            ></p-multiSelect>
            <label htmlFor="filtroLote">Lotes</label>
          </span>
        </div>
        <div class="col-4">
          <span class="p-float-label">
            <p-multiSelect
              [style]="stylePattern"
              [options]="equipamentos"
              optionLabel="nomeExterno"
              optionValue="equipamentoId"
              [(ngModel)]="filter.equipamentoId"
              inputId="filtroEquipamento"
              [showClear]="true"
              [filter]="true"
              placeholder="Selecionar"
              emptyMessage="Nenhum equipamento disponível"
            ></p-multiSelect>
            <label htmlFor="filtroEquipamento">Equipamentos</label>
          </span>
        </div>
      </div>

      <div class="grid mt-3">
        <div class="col-4">
          <span class="p-float-label">
            <p-calendar
              [style]="stylePattern"
              [(ngModel)]="filter.dataInicioOperacao"
              (ngModelChange)="onFiltroDataChange()"
              inputId="filtroDataInicio"
              dateFormat="dd/mm/yy"
              [showClear]="true"
            ></p-calendar>
            <label htmlFor="filtroDataInicio">Data Início Operação</label>
          </span>
        </div>
        <div class="col-4">
          <span class="p-float-label">
            <p-calendar
              [style]="stylePattern"
              [(ngModel)]="filter.dataFimOperacao"
              (ngModelChange)="onFiltroDataChange()"
              inputId="filtroDataFim"
              dateFormat="dd/mm/yy"
              [minDate]="$any(filter.dataInicioOperacao)"
              [showClear]="true"
            ></p-calendar>
            <label htmlFor="filtroDataFim">Data Fim Operação</label>
          </span>
        </div>
        <div class="col-4">
          <span class="p-float-label">
            <p-calendar
              [style]="stylePattern"
              [(ngModel)]="filter.dataInicioFaturamento"
              (ngModelChange)="onFiltroDataChange()"
              inputId="filtroDataFaturamento"
              dateFormat="dd/mm/yy"
              [minDate]="$any(filter.dataInicioOperacao)"
              [maxDate]="$any(filter.dataFimOperacao)"
              [showClear]="true"
            ></p-calendar>
            <label htmlFor="filtroDataFaturamento">Data Início Faturamento</label>
          </span>
        </div>
      </div>

      <div class="grid mt-3">
        <div class="col-4">
          <span class="p-float-label">
            <p-dropdown
              [style]="stylePattern"
              [options]="statusOptions"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="filter.ativo"
              inputId="filtroAtivo"
              [showClear]="true"
              placeholder="Todos"
            ></p-dropdown>
            <label htmlFor="filtroAtivo">Status</label>
          </span>
        </div>
        <div class="col-4">
          <span class="p-float-label">
            <p-multiSelect
              [style]="stylePattern"
              [options]="empresasOptions"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="filter.empresa"
              inputId="filtroEmpresa"
              [showClear]="true"
              [filter]="true"
              placeholder="Selecionar"
            ></p-multiSelect>
            <label htmlFor="filtroEmpresa">Empresa</label>
          </span>
        </div>
        <div class="col-4">
          <p-button
            class="mr-2"
            [style]="{ height: '40px' }"
            label="Filtrar"
            size="small"
            icon="pi pi-search"
            (onClick)="applyFilter()"
          ></p-button>
          <p-button
            [outlined]="true"
            [style]="{ height: '40px' }"
            label="Limpar Filtro"
            size="small"
            icon="pi pi-times"
            (onClick)="clearFilter()"
          ></p-button>
        </div>
      </div>
    </p-fieldset>
  </p-card>

  <!-- Tabela -->
  <p-card [styleClass]="!notFound ? '' : 'mb-3'">
    <p-toolbar [styleClass]="!notFound ? 'mb-4 gap-2' : ''">
      <ng-template pTemplate="left">
        <button
          pButton
          pRipple
          label="Novo Início de Operação"
          icon="pi pi-plus"
          class="p-button-primary mr-2"
          (click)="openCreate()"
        ></button>
      </ng-template>
    </p-toolbar>

    <p-table
      *ngIf="!notFound"
      [(first)]="first"
      [value]="data"
      [totalRecords]="totalRecords"
      [loading]="loading"
      [lazy]="true"
      [tableStyle]="{ 'min-width': '100%' }"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[10, 25, 50, 100]"
      (onLazyLoad)="onLazyLoad($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of columns" class="text-center" [style.width]="col.width">
            <b>{{ col.label }}</b>
          </th>
          <th class="text-center" style="width: 10%"><b>Ações</b></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-record>
        <tr>
          <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
            {{ record.equipamentoNome ?? '-' }}
          </td>
          <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
            {{ record.empresa ?? '-' }}
          </td>
          <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
            {{ record.dataInicioOperacao | date:'dd/MM/yyyy' }}
          </td>
          <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
            {{ record.dataFimOperacao | date:'dd/MM/yyyy' }}
          </td>
          <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
            {{ record.dataInicioFaturamento ? (record.dataInicioFaturamento | date:'dd/MM/yyyy') : '-' }}
          </td>
          <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
            {{ getLoteNome(record.loteId) }}
          </td>
          <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
            <p-tag
              [severity]="record.ativo ? 'success' : 'danger'"
              [styleClass]="record.ativo ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'"
              [value]="record.ativo ? 'Ativo' : 'Inativo'"
            ></p-tag>
          </td>
          <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
            <button
              pButton
              pRipple
              type="button"
              pTooltip="Editar"
              tooltipPosition="top"
              icon="pi pi-pencil"
              class="p-button-rounded p-button-info mr-2"
              (click)="openEdit(record)"
            ></button>
            <button
              pButton
              pRipple
              type="button"
              pTooltip="Excluir"
              tooltipPosition="top"
              icon="pi pi-trash"
              class="p-button-rounded p-button-danger"
              (click)="openDeleteConfirm(record)"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>

  <app-not-found-component
    *ngIf="notFound"
    [titulo]="tituloNotFound"
    [descricao]="descricaoNotFound"
  ></app-not-found-component>

  </p-tabPanel>

  <p-tabPanel header="Histórico">

    <!-- Filtros do histórico -->
    <p-card styleClass="my-3">
      <p-fieldset legend="Filtros" [toggleable]="true">
        <div class="grid mt-3">
          <div class="col-4">
            <span class="p-float-label">
              <p-multiSelect
                [style]="stylePattern"
                [options]="equipamentos"
                optionLabel="nomeExterno"
                optionValue="equipamentoId"
                [(ngModel)]="historyFilter.equipamentoId"
                inputId="histFiltroEquipamento"
                [showClear]="true"
                [filter]="true"
                placeholder="Selecionar"
                emptyMessage="Nenhum equipamento disponível"
              ></p-multiSelect>
              <label htmlFor="histFiltroEquipamento">Equipamentos</label>
            </span>
          </div>
          <div class="col-4">
            <span class="p-float-label">
              <p-multiSelect
                [style]="stylePattern"
                [options]="acaoOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="historyFilter.acao"
                inputId="histFiltroAcao"
                [showClear]="true"
                placeholder="Selecionar"
              ></p-multiSelect>
              <label htmlFor="histFiltroAcao">Ação</label>
            </span>
          </div>
          <div class="col-4">
            <span class="p-float-label">
              <p-multiSelect
                [style]="stylePattern"
                [options]="usuariosOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="historyFilter.userId"
                inputId="histFiltroUsuario"
                [showClear]="true"
                [filter]="true"
                placeholder="Selecionar"
              ></p-multiSelect>
              <label htmlFor="histFiltroUsuario">Usuário</label>
            </span>
          </div>
        </div>

        <div class="grid mt-3">
          <div class="col-12 flex align-items-end">
            <p-button
              class="mr-2"
              [style]="{ height: '40px' }"
              label="Filtrar"
              size="small"
              icon="pi pi-search"
              (onClick)="applyHistoryFilter()"
            ></p-button>
            <p-button
              [outlined]="true"
              [style]="{ height: '40px' }"
              label="Limpar Filtro"
              size="small"
              icon="pi pi-times"
              (onClick)="clearHistoryFilter()"
            ></p-button>
          </div>
        </div>
      </p-fieldset>
    </p-card>

    <!-- Tabela do histórico -->
    <p-card [styleClass]="!historyNotFound ? '' : 'mb-3'">
      <p-table
        *ngIf="!historyNotFound"
        [(first)]="historyFirst"
        [value]="historyData"
        [totalRecords]="historyTotalRecords"
        [loading]="historyLoading"
        [lazy]="true"
        [tableStyle]="{ 'min-width': '100%' }"
        [paginator]="true"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50, 100]"
        (onLazyLoad)="onHistoryLazyLoad($event)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="text-center" style="width: 24%"><b>Equipamento</b></th>
            <th class="text-center" style="width: 24%"><b>Usuário responsável</b></th>
            <th class="text-center" style="width: 24%"><b>Data/Hora da operação</b></th>
            <th class="text-center" style="width: 18%"><b>Ação</b></th>
            <th class="text-center" style="width: 10%"><b>Detalhes</b></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-record>
          <tr>
            <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
              {{ record.equipmentName ?? '-' }}
            </td>
            <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
              {{ record.userName ?? '-' }}
            </td>
            <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
              {{ record.dataAtualizacao | date:'dd/MM/yyyy HH:mm:ss' }}
            </td>
            <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
              <p-tag
                [severity]="getTipoOperacaoSeverity(record.acao)"
                [styleClass]="getTagSoftClass(getTipoOperacaoSeverity(record.acao))"
                [value]="getTipoOperacaoLabel(record.acao)"
              ></p-tag>
            </td>
            <td class="text-center" [style]="{ 'vertical-align': 'middle' }">
              <button
                pButton
                pRipple
                type="button"
                pTooltip="Detalhes"
                tooltipPosition="top"
                aria-label="Ver detalhes do histórico"
                icon="pi pi-info-circle"
                class="p-button-rounded p-button-secondary"
                (click)="openHistoryDetail(record)"
              ></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>

    <app-not-found-component
      *ngIf="historyNotFound"
      [titulo]="tituloNotFound"
      [descricao]="descricaoNotFound"
    ></app-not-found-component>

  </p-tabPanel>
  </p-tabView>

  <p-confirmDialog [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}"></p-confirmDialog>

  <!-- Dialog detalhes do histórico -->
  <p-dialog
    [(visible)]="historyDetailVisible"
    [modal]="true"
    [dismissableMask]="true"
    [style]="{ width: '55vw' }"
  >
    <ng-template pTemplate="header">
      <div class="flex align-items-center gap-3">
        <span class="p-dialog-title">Detalhes do Histórico</span>
        <span *ngIf="historyDetail" class="font-medium text-color-secondary">
          {{ getOperacaoModalLabel(historyDetail.acao) }}
        </span>
        <span *ngIf="historyDetail" class="text-sm text-color-secondary">
          · {{ historyDetailChangedCount }} de {{ historyDetailRows.length }} campos alterados
        </span>
      </div>
    </ng-template>

    <div
      *ngIf="historyDetail && historyDetailChangedCount === 0"
      class="text-center text-color-secondary py-5"
    >
      Nenhuma alteração de valor neste evento
    </div>

    <p-table
      *ngIf="historyDetail && historyDetailChangedCount > 0"
      [value]="historyDetailRows"
      styleClass="p-datatable-sm p-datatable-striped"
      [tableStyle]="{ 'min-width': '100%' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 34%"><b>Campo</b></th>
          <th style="width: 33%"><b>Anterior</b></th>
          <th style="width: 33%"><b>Atualizado</b></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [ngClass]="{ 'text-color-secondary opacity-50': row.muted }">
          <td class="font-semibold">{{ row.campo }}</td>
          <td>
            <p-tag
              *ngIf="row.showAnterior; else anteriorPlain"
              severity="danger"
              styleClass="line-through bg-red-100 text-red-700"
              [value]="row.anterior"
            ></p-tag>
            <ng-template #anteriorPlain>{{ row.muted ? row.anterior : '—' }}</ng-template>
          </td>
          <td>
            <p-tag
              *ngIf="row.showAtualizado; else atualizadoPlain"
              severity="success"
              styleClass="bg-green-100 text-green-700"
              [value]="row.atualizado"
            ></p-tag>
            <ng-template #atualizadoPlain>{{ row.muted ? row.atualizado : '—' }}</ng-template>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-dialog>

  <!-- Dialog criar/editar -->
  <p-dialog
    [(visible)]="showDialog"
    [modal]="true"
    [dismissableMask]="true"
    [style]="{ width: '55vw' }"
    [header]="editMode ? 'Editar Início de Operação' : 'Novo Início de Operação'"
  >
    <div class="grid">
      <div class="col-6 pt-5">
        <span class="p-float-label">
          <p-dropdown
            [scrollHeight]="'30rem'"
            [style]="stylePattern"
            [options]="contracts"
            inputId="formContrato"
            optionLabel="description"
            optionValue="id"
            [ngModel]="filter.contratoId"
            [disabled]="true"
            dropdownIcon="null"
            appendTo="body"
          ></p-dropdown>
          <label htmlFor="formContrato">Contrato</label>
        </span>
      </div>
      <div class="col-6 pt-5">
        <span class="p-float-label">
          <p-dropdown
            [style]="stylePattern"
            [options]="formEquipamentos"
            optionLabel="nomeExterno"
            optionValue="equipamentoId"
            [(ngModel)]="form.equipamentoId"
            inputId="formEquipamento"
            [filter]="true"
            [showClear]="true"
            [required]="true"
            [class]="!form.equipamentoId ? 'ng-invalid ng-dirty' : ''"
            placeholder="Selecionar"
            emptyMessage="Nenhum equipamento disponível"
            appendTo="body"
          ></p-dropdown>
          <label htmlFor="formEquipamento">Equipamento *</label>
        </span>
      </div>
    </div>

    <div class="grid">
      <div class="col-6 pt-5">
        <span class="p-float-label">
          <p-dropdown
            [style]="stylePattern"
            [options]="empresasOptions"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="form.empresa"
            inputId="formEmpresa"
            [filter]="true"
            [showClear]="true"
            [required]="true"
            [class]="!form.empresa ? 'ng-invalid ng-dirty' : ''"
            placeholder="Selecionar"
            emptyMessage="Nenhuma empresa disponível"
            appendTo="body"
          ></p-dropdown>
          <label htmlFor="formEmpresa">Empresa *</label>
        </span>
      </div>
            <div class="col-6 pt-5">
        <span class="p-float-label">
          <p-dropdown
            [style]="stylePattern"
            [options]="lotes"
            optionLabel="nome"
            optionValue="id"
            [(ngModel)]="form.loteId"
            inputId="formLote"
            [showClear]="true"
            [filter]="true"
            [required]="true"
            [class]="!form.loteId ? 'ng-invalid ng-dirty' : ''"
            placeholder="Selecionar"
            emptyMessage="Nenhum lote disponível"
            appendTo="body"
          ></p-dropdown>
          <label htmlFor="formLote">Lote *</label>
        </span>
      </div>
    </div>

    <div class="grid">
      <div class="col-6 pt-5">
        <span class="p-float-label">
          <p-calendar
            [style]="stylePattern"
            [(ngModel)]="form.dataInicioOperacao"
            (ngModelChange)="onFormDataChange()"
            inputId="formDataInicio"
            dateFormat="dd/mm/yy"
            [required]="true"
            [class]="!form.dataInicioOperacao ? 'ng-invalid ng-dirty' : ''"
            appendTo="body"
          ></p-calendar>
          <label htmlFor="formDataInicio">Data Início Operação *</label>
        </span>
      </div>
      <div class="col-6 pt-5">
        <span class="p-float-label">
          <p-calendar
            [style]="stylePattern"
            [(ngModel)]="form.dataFimOperacao"
            (ngModelChange)="onFormDataChange()"
            inputId="formDataFim"
            dateFormat="dd/mm/yy"
            [minDate]="$any(form.dataInicioOperacao)"
            [required]="true"
            [class]="!form.dataFimOperacao ? 'ng-invalid ng-dirty' : ''"
            appendTo="body"
          ></p-calendar>
          <label htmlFor="formDataFim">Data Fim Operação *</label>
        </span>
      </div>
    </div>

    <div class="grid">
      <div class="col-6 pt-5">
        <span class="p-float-label">
          <p-calendar
            [style]="stylePattern"
            [(ngModel)]="form.dataInicioFaturamento"
            (ngModelChange)="onFormDataChange()"
            inputId="formDataFaturamento"
            dateFormat="dd/mm/yy"
            [minDate]="$any(form.dataInicioOperacao)"
            [maxDate]="$any(form.dataFimOperacao)"
            [showClear]="true"
            appendTo="body"
          ></p-calendar>
          <label htmlFor="formDataFaturamento">Data Início Faturamento</label>
        </span>
      </div>
      <div class="col-6 pt-5">
        <div class="flex align-items-center" style="height: 40px">
          <p-checkbox
            [(ngModel)]="form.ativo"
            [binary]="true"
            label="Ativo"
            inputId="formAtivo"
          ></p-checkbox>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <p-button
          label="Cancelar"
          icon="pi pi-times"
          [outlined]="true"
          size="small"
          (onClick)="showDialog = false"
          [disabled]="buttonLoading"
        ></p-button>
        <p-button
          [label]="editMode ? 'Atualizar' : 'Salvar'"
          icon="pi pi-save"
          size="small"
          [loading]="buttonLoading"
          (onClick)="save()"
        ></p-button>
      </div>
    </ng-template>
  </p-dialog>
</div>
